import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
  /* istanbul ignore next */
  location: Location = window.location;
}
